/** @format */

import styled, { keyframes } from 'styled-components';

const from = keyframes` 
    from {
        width: 0%;
    }
    to {
        width: 100%;
    }
`;

const to = keyframes` 
    from {
        width: 100%;
    }
    to {
        width: 0%;
    }
`;

export const NavItemWrapper = styled.div`
	display: flex;
	flex-direction: column;
	font-family: Noto Sans TC;
	line-height: 23px;
	margin-top: 19px;
	cursor: pointer;
	& > div {
		& > a {
			color: #3b3b3a;
		}
	}
`;

export const MenuWrapper = styled.div`
	margin-top: 7px;
	${(props) => props.opacity && 'opacity: 0;height: 0;'}
	overflow: hidden;
	display: flex;
	position: absolute;
	flex-direction: column;
	border-radius: 8px;
	background: #f5f5f3;
	width: 180px;
`;

export const MenuVectorWrapper = styled.img`
	margin-left: 3px;
	margin-bottom: 3px;
`;

export const MenuGroupWrapper = styled.div`
	display: flex;
	height: 39px;
	padding: 8px 16px;
	background: ${(props) =>
		props.active ? 'rgba(59, 59, 58, 0.1)' : 'inherit'};
	color: black;
`;

export const MenuGroupContainer = styled.div`
	overflow: auto;
`;

export const MenuItemWrapper = styled.div`
	width: 100%;
	height: 39px;
	padding: 8px 16px;
	&:hover {
		background: rgba(59, 59, 58, 0.1);
	}
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const SelectBar = styled.div`
	width: 100%;
	height: 3px;
	background-color: #ffd934;
`;

export const NavAnimateBar = styled.div`
	width: 0%;
	height: 3px;
	background-color: rgba(59, 59, 58, 0.1);
	animation: ${(props) =>
		props.hover === '' ? 'none' : props.hover ? from : to};}
	animation-duration: 0.3s;
	animation-timing-function: ease-in-out;
	animation-direction: normal;
	animation-fill-mode: forwards;
`;

export const SearchBorder = styled.div`
	width: 100%;
	z-index: 10;
	margin-top: 12px;
	width: 266px;
	height: 40px;
	padding: 1px;
	border-radius: 20px;
	&: hover {
		background: linear-gradient(
			270deg,
			#ffd934 0%,
			rgba(245, 245, 243, 0) 100%
		);
	} ;
`;

export const SearchBackground = styled.div`
	border-radius: 26px;
	height: 38px;
	width: 264px;
	background: #ffffff;
`;

export const SearchWrapper = styled.div`
	size: 16px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	border-radius: 26px;
	height: 38px;
	width: 264px;
	background: linear-gradient(270deg, #f5f5f3 0%, rgba(245, 245, 243, 0) 100%);
`;

export const SearchTitleWrapper = styled.div`
	color: #3b3b3a;
	padding: 0 6px;
	font-size: 16px;
	white-space: nowrap;
	width: 48px;
	display: inline;
`;

export const MDSearchTitleWrapper = styled.div`
	font-size: 16px;
	white-space: nowrap;
	width: 48px;
	display: inline;
	color: #3b3b3a;
`;

export const SearchInputWrapper = styled.div`
	margin-left: 2px;
	display: inline;
	caret-color: #ffd934;
	& > input {
		font-size: inherit;
		background: inherit;
		::placeholder {
			color: rgba(59, 59, 58, 0.4);
		}
	}
`;

export const SearchIconWrapper = styled.div`
	margin-right: 4px;
	width: 40px;
	height: 32px;
	padding: 4px 10px;
	border-radius: 20px;
	display: inline;
	background-color: #ffd934;
	cursor: pointer;
	font-size: 20px;
	display: flex;
	justify-content: center;
	align-items: center;

	& > img {
		&:active {
			width: 18px;
			height: 18px;
		}
	}
`;

export const LanguageWrapper = styled.div`
	margin-top: 12px;
`;

export const MDIconWrapper = styled.div`
	margin-top: 4px;
	display: flex;
	justify-content: center;
	align-items: center;

	& > div {
		& > img {
			&:active {
				width: 18px;
				height: 18px;
			}
		}
	}
`;

export const MDIconImg = styled.img`
	margin-right: 25px;
`;

export const MDSearchBorder = styled.div`
	height: 56px;
	width: 100%;
	position: fixed;
	z-index: 10;
	border-radius: 20px;
	${(props) =>
		!props.focus &&
		`&: hover {
		background: linear-gradient(
			270deg,
			#ffd934 0%,
			rgba(245, 245, 243, 0) 100%
		);
	}`}
	${(props) => props.focus && 'background: #000000'}
`;
export const MDWrapper = styled.div`
	background: #f5f5f3;
	height: 54px;
	padding: 13px 15px 0 0px;

	& .search {
		margin-top: -3px;
	}
`;

export const EmptyWrapper = styled.div`
	width: 100%;
	height: 64px;
`;
